// src/pages/MeoAIPage.jsx
import ComingSoon from '../components/common/ComingSoon';

const MeoAIPage = () => {


  return (
    <div className="max-w-5xl mx-auto px-4 py-6">
                 <ComingSoon />

    </div>
  );
};

export default MeoAIPage;